<template>
  <div>
    <headerComponent />

    <div class="indexMain">
      <div class="banner">
        <div class="swiper-container swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide slide"
              v-for="(banner, index) in banners"
              :key="index"
              @click="geturl(banner)"
            >
              <!-- <router-link :to="{ name: 'machine' }"> -->
              <img :src="banner.tu" alt="banner" />
              <!-- </router-link> -->
            </div>
          </div>
          <!-- 分页器 -->
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <div class="indexOne">
        <div class="w1300">
          <div class="tle">
            <h3 class="tit-42">热门产品</h3>

            <div class="swjtBox">
              <div class="swiper-button-prev swjt"></div>
              <div class="swiper-button-next swjt"></div>
            </div>
          </div>

          <div class="swiperBox">
            <div class="swiper-container swiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide slide"
                  v-for="(list, index) in inOnelist"
                  :key="index"
                  @click="$router.push()"
                >
                  <router-link
                    :to="{ name: 'prodetail', params: { id: list.id } }"
                  >
                    <div class="imgBox flex-cc">
                      <img :src="list.tu" alt="" />
                      <div class="tips" v-if="list.tip">{{ list.tip }}</div>
                    </div>
                    <div class="con txt-c">
                      <div class="name tit-22 fw700 cor-333">
                        {{ list.ming }}
                      </div>
                      <div class="price tit-20 mt-10">
                        ¥<span>{{
                          list.jiage && isdenglu
                            ? list.jiage
                            : "销售指导价 联系销售顾问"
                        }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerComponent />
  </div>
</template>

<script>
import headerComponent from "../components/header.vue";
import footerComponent from "../components/footer.vue";
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  name: "HomeIndex",
  data() {
    return {
      banners: [],
      inOnelist: [],
      // 保存swiper实例，方便后续更新
      bannerSwiper: null,
      productSwiper: null,
      isdenglu: false,
    };
  },
  components: {
    headerComponent,
    footerComponent,
  },
  mounted() {
    // 先请求数据，再初始化swiper
    this.initData();
  },
  methods: {
    // 统一初始化数据
    async initData() {
      try {
        // 并行请求banner和产品数据
        await Promise.all([this.Qubanner(), this.CSH()]);
        // 数据加载完成后初始化swiper
        this.getSwiper();
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },
    geturl(l) {
      window.location.href = l.url;
    },
    // 获取产品数据
    CSH() {
      return new Promise((resolve) => {
        this.$post("k=shangpin", { ye: 1, jitiao: 9, hot: 1 }, (s) => {
          this.inOnelist = s.shu.lie;
          resolve();
          // 如果swiper已初始化，更新swiper
          if (this.productSwiper) {
            this.productSwiper.update();
          }
          if (this.$qu("yonghux")["id"]) {
            this.isdenglu = true;
          } else {
            this.isdenglu = false;
          }
        });
      });
    },
    // 获取banner数据
    Qubanner() {
      return new Promise((resolve) => {
        this.$post(
          "k=company&c=Banner",
          { ye: 1, jitiao: 3, leixing: 0 },
          (s) => {
            this.banners = s.shu.lie;
            resolve();
            // 如果swiper已初始化，更新swiper
            if (this.bannerSwiper) {
              this.bannerSwiper.update();
            }
          },
        );
      });
    },
    // 初始化swiper
    getSwiper() {
      // 初始化banner swiper
      this.bannerSwiper = new Swiper(".banner .swiper", {
        loop: true,
        slidesPerView: 1,
        loopAdditionalSlides: 3,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination", // 修复选择器多余的空格
          clickable: true,
        },
		 autoplay: {
		      delay: 2000, // 自动轮播间隔时间（毫秒），3000=3秒
		      disableOnInteraction: false, // 手动滑动后是否继续自动轮播（false=继续）
		      pauseOnMouseEnter: true, // 鼠标悬停时暂停轮播（体验更好）
		    },
        // 确保初始化时计算正确
        observer: true, // 监听swiper容器变化
        observeParents: true, // 监听swiper父元素变化
      });

      // 初始化产品swiper
      this.productSwiper = new Swiper(".indexOne .swiper", {
        // loop: true,
        slidesPerView: 3,
        spaceBetween: 25,
		// autoplay: {
		//       delay: 2000, // 产品轮播间隔4秒（可自定义）
		//       disableOnInteraction: false,
		//       pauseOnMouseEnter: true,
		//     },
        navigation: {
          nextEl: ".indexOne .swiper-button-next",
          prevEl: ".indexOne .swiper-button-prev",
        },
        // 关键配置：监听元素变化自动更新
        observer: true,
        observeParents: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },

          200: {
            slidesPerView: 1.5,
          },
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 原有样式保持不变 */
.banner {
  position: relative;
  .slide img {
    width: 100%;
    cursor: pointer;
  }

  .swiper {
    /deep/ .swiper-pagination {
      bottom: 0.4rem;
    }

    /deep/ .swiper-pagination-bullet {
      width: 10px;
      height: 10px;
      display: inline-block;
      opacity: 0.5;
      background: #ffffff;
    }
    /deep/ .swiper-pagination-bullet-active {
      opacity: 0.75;
      background: #333333;
    }
  }
}

.indexOne {
  padding: 0.8rem 0 1rem;
  .tle {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .swjtBox {
    position: relative;
    display: flex;
    align-items: center;
    .swjt {
      width: 0.51rem;
      height: 0.51rem;
      opacity: 0.5;
      border: 2px solid #cfcfcf;
      position: relative;
      border-radius: 50%;
      margin: 0;
      left: 0;
      right: 0;
      transition: 0.5s;

      &:hover {
        opacity: 1;
        border-color: #41b9e0;
        &::after {
          color: #41b9e0;
        }
      }
    }
    .swiper-button-prev {
      margin-right: 10px;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
      font-size: 12px;
      font-weight: 700;
      color: #c6c6c6;
    }
  }

  .swiperBox {
    margin-top: 0.4rem;
    .swiper {
      padding: 0.1rem;
    }

    .slide {
      border-radius: 10px;
      background-color: rgb(255, 255, 255);
      height: auto;
      overflow: hidden;
      box-shadow: 0rem 0rem 0.09rem 0rem rgba(0, 0, 0, 0.1);
      a {
        display: block;
        height: 100%;
      }

      .imgBox {
        height: 3rem;
        background: url("../assets/indexOne-slide-bj.jpg") no-repeat center;
        background-size: cover;

        img {
          max-width: 80%;
          max-height: 80%;
          transition: 0.5s;
        }

        .tips {
          font-family: Arial, Arial-Bold;
          font-weight: 700;
          background-color: #e92f27;
          color: white;
          width: 90%;
          top: 0;
          right: 0;
          font-size: 12px;
          text-align: center;
          padding: 2px 0;
          margin-top: 0.1rem;
          position: absolute;
          transform: translateX(45%) rotate(45deg);
        }
      }

      .con {
        padding: 0.3rem 0.1rem;
      }

      &:hover img {
        transform: scale(1.05);
      }
    }
  }
}

@media screen and (max-width: 767px) {
  /deep/ .banner .swiper {
    .swiper-pagination {
      bottom: 0.2rem;
      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
      }
    }
  }
}
</style>
